/* Floating dock (Aisles, Message us) and the category bar's scroll helpers. Plain JS, progressive enhancement. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var store = {
    get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { v ? sessionStorage.setItem(k, v) : sessionStorage.removeItem(k); } catch (e) {} }
  };

  /* ---------- aisles: a panel that never blocks the page ---------- */
  var aBtn = $('.dock [data-aisles-toggle]') || $('[data-aisles-toggle]'), aPanel = $('#aislePanel');
  function setAisles(open, silent) {
    if (!aPanel || !aBtn) return;
    aPanel.hidden = !open;
    $$('[data-aisles-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', String(open)); b.classList.toggle('on', open); });
    if (open && !silent) { var cur = $('[aria-current="page"]', aPanel) || $('a', aPanel); if (cur && cur.focus) cur.focus({ preventScroll: true }); }
  }
  if (aBtn && aPanel) {
    $$('[data-aisles-toggle]').forEach(function (b) { b.addEventListener('click', function () { setAisles(aPanel.hidden); }); });
    // phones: a tap outside the panel closes it, like any sheet
    document.addEventListener('click', function (e) { if (!aPanel.hidden && innerWidth <= 680 && !aPanel.contains(e.target) && !e.target.closest('[data-aisles-toggle]')) setAisles(false); });
    // with a mouse, the panel disappears when the pointer leaves it; with the keyboard or touch it stays until closed
    var dockL = aBtn.closest('.dock'), leaveT = 0;
    if (dockL && matchMedia('(hover: hover) and (pointer: fine)').matches) {
      dockL.addEventListener('mouseenter', function () { clearTimeout(leaveT); });
      dockL.addEventListener('mouseleave', function () {
        clearTimeout(leaveT);
        leaveT = setTimeout(function () { if (!aPanel.hidden && !dockL.matches(':hover') && !aPanel.contains(document.activeElement)) setAisles(false); }, 260);
      });
    }
    // every "store map" style link opens this panel instead of a blocking dialog
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-map]');
      if (!t) return;
      e.preventDefault(); e.stopImmediatePropagation(); setAisles(true);
    }, true);
  }

  /* ---------- messages ---------- */
  var mBtn = $('[data-msg-toggle]'), mPanel = $('#msgPanel'), form = $('form.msg-form', mPanel || document),
      done = $('[data-msg-done]'), body = $('[data-msg-body]'), err = $('[data-msg-err]');
  function setMsg(open) {
    if (!mPanel || !mBtn) return;
    mPanel.hidden = !open; mBtn.setAttribute('aria-expanded', String(open)); mBtn.classList.toggle('on', open);
    if (open) { if (innerWidth <= 900 && aPanel && !aPanel.hidden) setAisles(false); var f = $('input[type=email]', mPanel); if (f && !f.value) f.focus({ preventScroll: true }); else { var t = $('textarea', mPanel); t && t.focus({ preventScroll: true }); } }
  }
  if (mBtn && mPanel && form) {
    mBtn.addEventListener('click', function () { setMsg(mPanel.hidden); });
    /* any [data-msg-open] button on the page (About, FAQ) opens the same panel */
    document.addEventListener('click', function (e) { var o = e.target.closest && e.target.closest('[data-msg-open]'); if (o) { e.preventDefault(); setMsg(true); } });
    $$('[data-msg-topic]', mPanel).forEach(function (b) {
      b.addEventListener('click', function () { var ta = $('textarea', form); if (ta) { ta.value = b.getAttribute('data-msg-topic') + '\n\n'; ta.focus(); } });
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault(); err.hidden = true;
      var ta = $('textarea', form), hp = $('#msgSite', form);
      var showDone = function () { body.hidden = true; done.hidden = false; ta.value = ''; done.focus(); };
      if (hp && hp.value) { showDone(); return; }                                   // a bot filled the hidden field
      var pg = $('[data-msg-page]', form); if (pg) pg.value = location.pathname;
      var fd = new FormData(form); fd.delete('contact[website]');
      fd.set('contact[body]', ta.value + '\n\n(Sent from ' + location.pathname + ')');
      var btn = $('button[type=submit]', form); btn.disabled = true; btn.textContent = 'Sending…';
      fetch(form.action, { method: 'POST', body: fd, credentials: 'same-origin', redirect: 'follow' }).then(function (r) {
        if (/\/challenge/.test(r.url)) {                                           // Shopify wants a quick human check: send the form the normal way
          ta.value = fd.get('contact[body]'); if (hp) hp.disabled = true; HTMLFormElement.prototype.submit.call(form); return;
        }
        var ok = r.ok && /contact_posted=true|posted_successfully/.test(r.url);
        if (!ok) throw new Error('not sent');
        showDone();
      }).catch(function () { err.hidden = false; }).finally(function () { btn.disabled = false; btn.textContent = 'Send message'; });
    });
    var again = $('[data-msg-again]'); if (again) again.addEventListener('click', function () { done.hidden = true; body.hidden = false; });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (mPanel && !mPanel.hidden) { setMsg(false); mBtn.focus(); }
    else if (aPanel && !aPanel.hidden && aPanel.contains(document.activeElement)) { setAisles(false); aBtn.focus(); }
  });
  $$('[data-dock-close]').forEach(function (b) {
    b.addEventListener('click', function () { var p = b.closest('.dock-panel'); if (p === aPanel) { setAisles(false); aBtn.focus(); } else { setMsg(false); mBtn.focus(); } });
  });

  if (location.hash === '#aisles') setAisles(true, true);
  if (location.hash === '#message') setMsg(true);

  /* ---------- category bar: arrows, edge fades, drag, current link in view ---------- */
  var nav = $('.subnav .wrap'), ul = nav && $('ul', nav);
  if (ul) {
    var l = document.createElement('button'), r = document.createElement('button');
    l.type = r.type = 'button'; l.className = 'sn-arrow sn-l'; r.className = 'sn-arrow sn-r';
    l.setAttribute('aria-label', 'Scroll categories left'); r.setAttribute('aria-label', 'Scroll categories right');
    l.innerHTML = r.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    l.firstChild.style.transform = 'scaleX(-1)';
    nav.appendChild(l); nav.appendChild(r);
    var dsk = $('.dept-btn.dsk', nav);
    var place = function () { var left = ul.offsetLeft - nav.getBoundingClientRect().left; nav.style.setProperty('--dsk-w', Math.max(0, left) + 'px'); };
    var upd = function () {
      place();
      var max = ul.scrollWidth - ul.clientWidth, x = ul.scrollLeft;
      nav.classList.toggle('can-l', x > 6); nav.classList.toggle('can-r', x < max - 6);
    };
    var step = function (d) { ul.scrollBy({ left: d * Math.max(200, ul.clientWidth * 0.7), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); };
    l.addEventListener('click', function () { step(-1); }); r.addEventListener('click', function () { step(1); });
    ul.addEventListener('scroll', upd, { passive: true }); addEventListener('resize', upd);
    var cur = $('[aria-current="page"]', ul); if (cur) ul.scrollLeft = Math.max(0, cur.offsetLeft - ul.clientWidth / 3);
    upd(); setTimeout(upd, 400);
    // drag with a mouse
    var down = false, sx = 0, sl = 0, moved = false;
    ul.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = ul.scrollLeft; });
    addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 4) { moved = true; ul.scrollLeft = sl - dx; } });
    addEventListener('pointerup', function () { down = false; });
    ul.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } }, true);
  }
})();
